"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), Object.defineProperty(exports, "classWriter", {
  enumerable: !0,
  get: function get() {
    return _function.classWriter;
  }
}), exports.classReWriter = exports.propWriter = void 0;

var _function = require("./function"),
    propWriter = function propWriter() {
  var a = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {};
  return function () {
    var b = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {},
        c = ["class", "className", "rewrite"],
        d = function d(a) {
      return c.includes(a);
    },
        e = (0, _function.commonKeys)(a)(b).filter(function notReserved(a) {
      return !d(a);
    });

    return 0 === e.length ? {} : (0, _function.pick)(e)(a);
  };
};

exports.propWriter = propWriter;

var classReWriter = function classReWriter() {
  var a = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {};
  if (a === void 0 || {} === a) return {};

  if ((0, _function.hasOwnProperty)(a, "rewrite")) {
    var b = a.rewrite;
    if (!0 === b) return {
      className: !0,
      rewrite: !0
    };
    if (void 0 !== b) return {
      className: "".concat(b),
      rewrite: !0
    };
  }

  return {};
};

exports.classReWriter = classReWriter;